/** The display metadata the backup stamps on a channel's or a chat's folder in the snapshot index. */
interface Microsoft365TeamsMessageAttributes {
  conversationName?: string;
  membershipType?: string;
  /** A chat's type: oneOnOne, group or meeting. */
  conversationKind?: string;
}

export function parseMicrosoft365TeamsMessageAttributes(
  attributes?: string
): Microsoft365TeamsMessageAttributes {
  if (!attributes) {
    return {};
  }
  try {
    const raw: Record<string, unknown> = JSON.parse(attributes);
    const str = (key: string) =>
      typeof raw[key] === 'string' ? raw[key] : undefined;
    return {
      conversationName: str('conversation_name'),
      membershipType: str('m365_teams_membership_type'),
      conversationKind: str('conversation_kind'),
    };
  } catch {
    return {};
  }
}
